<template>
  <div ref="map" id="google-map" class="w-full h-64 lg:h-full" />
</template>

<script>
import {Loader, LoaderOptions} from 'google-maps'

export default {
  name: 'Google-Map',
  props: {
    modal: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      lat: 32.782775,
      lng: -96.784302,
      loaded: false,
      map: null,
      overlay: null,
      google: null,
      entries: {},
      activeMarker: null,
      markers: [],
      zoom: 16,
      mapType: 'foodDrink',
      places: [],
      options: {
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        zoomControl: true,
        gestureHandling: 'cooperative',
        suppressInfoWindows: true,
        disableDefaultUI: true,
        styles: this.addStyles()
      },
      defaultMarker: null,
      hoverMarker: null,
      markerImages: {
        foodDrink: 'https://optimise2.assets-servd.host/willing-hornbill/production/images/maps/map-marker-default-2x.png?w=40&auto=compress%2Cformat&fit=crop&fp-x=0.5&fp-y=0.5&crop=focalpoint&s=4cfd5fd31adc322e8fc55ae374fc2eb1',
        artsEntertainment: 'https://optimise2.assets-servd.host/willing-hornbill/production/images/maps/map-marker-arts-2x.png?w=39&auto=compress%2Cformat&fit=crop&fp-x=0.5&fp-y=0.5&crop=focalpoint&s=e89b91b5c76ce644db7ed79ced2287ab',
        retailServices: 'https://optimise2.assets-servd.host/willing-hornbill/production/images/maps/map-marker-retail-2x.png?w=39&auto=compress%2Cformat&fit=crop&fp-x=0.5&fp-y=0.5&crop=focalpoint&s=4ab0512a74ed42911ca30b473a01e70e',
        living: 'https://optimise2.assets-servd.host/willing-hornbill/production/images/maps/map-marker-living-2x.png?w=39&auto=compress%2Cformat&fit=crop&fp-x=0.5&fp-y=0.5&crop=focalpoint&s=8f1232885eb1178ff95763525c037d4b'
      }
    }
  },
  async mounted () {
    this.fetchResults();
  },
  methods: {
    async fetchResults() {
      let type = window.location.pathname.split("/").pop().split('-')

      if (type.length > 1) {
        type = `${type[0]}${type[1].replace(/^\w/, (c) => c.toUpperCase())}`
      }

      if (type === 'shopsAnd') {
        type = 'retailServices'
      }

      const query = `
        query {
          entries(orderBy: "title", type: "${type}") {
            ... on places_foodDrink_Entry {
              id
              type: __typename
              title
              place {
                address
                lat
                lng
                parts {
                  number
                  address
                  city
                  state
                  postcode
                }
              }
              details: locationDetails {
                type: __typename
                ... on locationDetails_BlockType {
                  subtitle
                  image {
                    url
                  }
                  description
                  walkingEta
                  website
                  phoneNumber
                }
              }
            }
            ... on places_living_Entry {
              id
              type: __typename
              title
              place {
                address
                lat
                lng
                parts {
                  number
                  address
                  city
                  state
                  postcode
                }
              }
              details: locationDetails {
                type: __typename
                ... on locationDetails_BlockType {
                  subtitle
                  image {
                    url
                  }
                  description
                  walkingEta
                  website
                  phoneNumber
                }
              }
            }
            ... on places_retailServices_Entry {
              id
              type: __typename
              title
              place {
                address
                lat
                lng
                parts {
                  number
                  address
                  city
                  state
                  postcode
                }
              }
              details: locationDetails {
                type: __typename
                ... on locationDetails_BlockType {
                  subtitle
                  image {
                    url
                  }
                  description
                  walkingEta
                  website
                  phoneNumber
                }
              }
            }
            ... on places_artsEntertainment_Entry {
              id
              type: __typename
              title
              place {
                address
                lat
                lng
                parts {
                  number
                  address
                  city
                  state
                  postcode
                }
              }
              details: locationDetails {
                type: __typename
                ... on locationDetails_BlockType {
                  subtitle
                  image {
                    url
                  }
                  description
                  walkingEta
                  website
                  phoneNumber
                }
              }
            }
          }
        }
      `;
      let response = await fetch('/api', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query })
      })

      if (response.ok) {
        let json = await response.json();
        this.places = json.data.entries
        await this.initMap();
      }

      return []
    },
    async initMap () {
      const { Loader } = require('google-maps');
      const loader = new Loader('AIzaSyAdBXRfE9-TE8O7lOnWbzcsJtyeMueiM0Q', {})
      this.mapType = this.places[0].type.split("_")[1];

      const google = await loader.load()
      this.map = new google.maps.Map(this.$refs.map, {
        center: {
          lat: this.lat,
          lng: this.lng
        },
        zoom: this.zoom,
        styles: this.addStyles(),
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        zoomControl: true,
        gestureHandling: 'cooperative',
        suppressInfoWindows: true,
        disableDefaultUI: true,
      })

      this.initMarkers(this.map)
      this.addStack('The Stack', this.map)
    },
    initMarkers (map) {
      if (this.markers.length > 0) {
        this.markers = []
      }

      this.places.forEach((entry) => {
        if (entry.place !== undefined) {
          this.addMarker(entry)
        }
      })

      map.markers = this.markers

      this.setMapOnAll(map)
    },
    addMarker (entry) {
      this.defaultMarker = {
        url: this.markerImages[this.mapType],
        scaledSize: new google.maps.Size(20, 20),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0)
      }

      this.hoverMarker = {
        url: 'https://optimise2.assets-servd.host/willing-hornbill/production/images/maps/map-pin-highlight.png?w=38&auto=compress%2Cformat&fit=crop&fp-x=0.5&fp-y=0.5&crop=focalpoint&s=ab528f01e3ca9dc4a1f21b071de376a1',
        scaledSize: new google.maps.Size(22, 22),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 0)
      }

      const marker = new google.maps.Marker({
        position: {
          lat: entry.place.lat,
          lng: entry.place.lng
        },
        id: entry.id,
        title: entry.title,
        icon: this.defaultMarker,
        optimized: false,
        animation: google.maps.Animation.DROP
      })

      marker.addListener('click', (e) => {
        if (this.activeMarker !== null) {
          this.clearMarker();
        }

        // marker.setIcon(this.hoverMarker)
        this.$emit('markerClicked', marker.id)
        this.activeMarker = marker; 
      })

      marker.addListener('mouseover', (e) => {
        marker.setIcon(this.hoverMarker)
      })

      marker.addListener('mouseout', () => {
        if (this.activeMarker === null || this.activeMarker.id !== marker.id) {
          marker.setIcon(this.defaultMarker)
        }
      })

      this.markers.push(marker)
    },
    addStack (title, map) {
      const marker = new google.maps.Marker({
        position: {
          lat: this.lat,
          lng: this.lng
        },
        map,
        title,
        icon: {
          url: 'https://cdn2.assets-servd.host/willing-hornbill/production/images/maps/stack-marker.svg',
          size: new google.maps.Size(68, 30),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(0, 0)
        },
        zIndex: 99999
      })

      this.map = map;
    },
    clearMarker() {
      this.activeMarker.setIcon(this.defaultMarker);
      this.activeMarker = null;
    },
    setMapOnAll (map) {
      this.markers.forEach((marker) => {
        marker.setMap(map)
      })
    },
    addStyles () {
      return [
        {
          featureType: 'all',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#eae8e1'
            }
          ]
        },
        {
          featureType: 'all',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffffff'
            },
            {
              visibility: 'on'
            }
          ]
        },
        {
          featureType: 'all',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#b9b7b1'
            }
          ]
        },
        {
          featureType: 'all',
          elementType: 'labels.icon',
          stylers: [
            {
              saturation: '100'
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#b9b7b1'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'all',
          stylers: [
            {
              color: '#f2f2f2'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#f8f8f6'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'poi.attraction',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [
            {
              saturation: -100
            },
            {
              lightness: 45
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry.fill',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#eae8e1'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#b9b7b1'
            },
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.fill',
          stylers: [
            {
              saturation: '0'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#b9b7b1'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#b9b7b1'
            }
          ]
        },
        {
          featureType: 'transit',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'all',
          stylers: [
            {
              color: '#46bcec'
            },
            {
              visibility: 'on'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#d5edeb'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'labels.text',
          stylers: [
            {
              color: '#b9b7b1'
            }
          ]
        }
      ]
    }
  },
  watch: {
    modal (newValue, oldValue) {
      if (newValue === '') {
        this.clearMarker();
      } else {
        if (this.activeMarker !== null) {
          this.clearMarker();
        }

        this.activeMarker = this.map.markers.find(marker => marker.id === newValue);
        this.activeMarker.setIcon(this.hoverMarker);
      }
    },
    activeMarker (marker) {
      this.activeMarker.setIcon(this.hoverMarker);
    }
  },
}
</script>

<style lang="scss">
#map {
  padding: 0 .9375rem;
}

.flush,
#map {
  height: 100%;
}
</style>
